module.exports = __webpack_public_path__ + "static/media/arrowRightAlt.68118b66.svg";